import { Grid, Button, FormControl } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import TextField from '@mui/material/TextField'
import ExitIcon from '@material-ui/icons/ExitToApp'
import ReactTooltip from 'react-tooltip'
import { useHistory, useLocation } from 'react-router-dom'
// import Divider from '@mui/material/Divider'
/* eslint-disable no-unused-vars */
import { useForm } from '../../../../context/formContext'
import CircularProgress from '@mui/material/CircularProgress'
import Box from '@mui/material/Box'
// import EditIcon from '@mui/icons-material/Edit'
import Modal from '@mui/material/Modal'
import Typography from '@mui/material/Typography'
import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'
import TextareaAutosize from '@mui/material/TextareaAutosize'
import { updateStatusForms } from '../../../../services/Forms/get'
import Switch from '@mui/material/Switch'
import { useAuthentication } from '../../../../context/authenticationContext'
import './styles/detailsForm.scss'
import FileDownloadIcon from '@mui/icons-material/FileDownload'
import NumberFormat from 'react-number-format'

const DetailsForm = (props) => {
  const history = useHistory()
  const location = useLocation()
  const { userID } = useAuthentication()

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 600,
    bgcolor: '#fff',
    border: 'none',
    boxShadow: 24,
    p: 4,
  }

  const [open, setOpen] = React.useState(false)
  // const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)

  const {
    getDetailsFormIFI,
    idDetailForm,
    setIdDetailForm,
    detailsListForm,
    loadingPDF,
    downloadPreIFIPDF,
  } = useForm()

  const [formData, setFormData] = useState([])

  const cancelForm = () => {
    history.push('/IFI/Formularios/Enviados')
  }

  const [actualStatus, setActualStatus] = useState(1)
  const [observations, setObservations] = useState('')
  const [amountChange, setAmountChange] = useState(false)
  const [loadingUpdate, setLoadingUpdate] = useState(false)

  const [buttonEnable, setButtonEnable] = useState(false)

  const updateStatus = async () => {
    if (
      buttonEnable &&
      idDetailForm !== 0 &&
      idDetailForm !== undefined &&
      actualStatus !== 0 &&
      actualStatus !== undefined &&
      observations !== undefined &&
      observations !== ''
    ) {
      const idUserAzureB2C = userID

      setButtonEnable(false)
      setLoadingUpdate(true)
      const res = await updateStatusForms(
        idDetailForm,
        actualStatus,
        idUserAzureB2C,
        amountChange,
        observations,
      )

      if (
        res.response.mensaje ===
        'Formulario de Pre-Elegibilidad actualizado exitosamente.'
      ) {
        setLoadingUpdate(false)
        history.push('/IFI/Formularios/Enviados')
      }
    }
    // updateStatusForms(idDetailForm, actualStatus, observations)
  }

  const { statesCodes, setFetchRequest } = useForm()

  useEffect(() => {
    setFetchRequest(['details_page'])

    if (location.state !== undefined) {
      setFormData(location.state)
      setIdDetailForm(location.state.IdForm)
    } else {
      history.push('/IFI/Formularios/Enviados')
    }

    if (
      idDetailForm !== undefined &&
      idDetailForm !== '' &&
      idDetailForm > 0 &&
      idDetailForm !== null &&
      location.state !== undefined
    ) {
      getDetailsFormIFI()
    }
  }, [idDetailForm])

  const handleState = (e) => {
    setActualStatus(e)
  }

  const handleObservations = (e) => {
    setObservations(e)
  }

  const handleSwitchChange = (e) => {
    setAmountChange(e.target.checked)
  }

  useEffect(() => {
    if (
      idDetailForm !== 0 &&
      idDetailForm !== undefined &&
      actualStatus !== 0 &&
      actualStatus !== undefined &&
      observations !== undefined &&
      observations !== ''
    ) {
      setButtonEnable(true)
      // prueba
    }
  }, [actualStatus, observations])

  const [impactos, setImpactos] = useState([])

  useEffect(() => {
    if (detailsListForm.list && detailsListForm.list.NegativeImpact) {
      const myArray = detailsListForm.list.NegativeImpact.split('|')
      const newArray = myArray.filter((i) => i !== '')
      setImpactos(newArray)
    }
  }, [detailsListForm.list])

  const [selectedClass, setSelectedClass] = useState('')
  const [percentageClass, setPercentageClass] = useState('')

  const handlePercentage = (value) => {
    const valor = value.split('|')
    const val = parseInt(valor[0])

    if (val === 1) {
      setSelectedClass('Clase I')
      setPercentageClass(' (0% - 2%)')
    }

    if (val === 2) {
      setSelectedClass('Clase II')
      setPercentageClass(' (2% - 4%)')
    }

    if (val === 3) {
      setSelectedClass('Clase III')
      setPercentageClass(' (4% - 12%)')
    }

    if (val === 4) {
      setSelectedClass('Clase IV')
      setPercentageClass(' (12% - 25%)')
    }
  }

  const handleClass = () => {}

  useEffect(() => {
    if (detailsListForm.list && detailsListForm.list.AnnexAnswer !== null) {
      detailsListForm.list.AnnexAnswer.map((item) => {
        if (
          item?.activityQuestion?.toLowerCase() ===
          'Porcentaje de pendiente del terreno'.toLowerCase()
        ) {
          handlePercentage(item.answer)
          handleClass(item.answer)
        }
        return 0
      })
    }
  }, [detailsListForm.list])

  return (
    <Grid md={12} sm={12} xs={12} className="detailsContainer">
      {!detailsListForm.loading && detailsListForm.list !== undefined ? (
        <Grid md={12} sm={12} xs={12}>
          <Grid className="detailButtonActions">
            <div
              data-tip
              data-for="exitPop"
              style={{
                backgroundColor: 'red',
                color: '#fff',
                width: '40px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: '4px',
                padding: '5px',
                cursor: 'pointer',
                marginRight: '20px',
              }}
              onClick={() => cancelForm()}
            >
              <ExitIcon style={{ transform: 'scaleX(-1)' }} />
              <ReactTooltip id="exitPop" effect="solid" backgroundColor="red">
                <span>Regresar</span>
              </ReactTooltip>
            </div>

            <div
              data-tip
              data-for="updatePop"
              style={{
                backgroundColor: '#009246',
                color: '#fff',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: '4px',
                padding: '5px',
                cursor: 'pointer',
                width: '40px',
              }}
              onClick={() =>
                downloadPreIFIPDF(
                  formData.IdForm,
                  formData.ProjectPreElegibilityCode,
                  undefined,
                )
              }
              disabled={loadingPDF}
            >
              {loadingPDF ? (
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <CircularProgress
                    style={{ color: '#fff', width: '23.5px', height: '23.5px' }}
                  />
                </Box>
              ) : (
                <FileDownloadIcon style={{ transform: 'scaleX(-1)' }} />
              )}
              <ReactTooltip
                id="updatePop"
                effect="solid"
                backgroundColor="#009246"
              >
                <span>Descargar </span>
              </ReactTooltip>
            </div>
          </Grid>
          <Grid md={12} sm={12} xs={12} className="subContainer">
            <Grid className="subContainerTitle">
              <h1>Detalles Del Formulario</h1>
              <p className="mecss">
                Visualice los detalles de un formulario enviado
              </p>
              <span className="formIDDetail">
                #{' '}
                {detailsListForm.list.PENumber
                  ? detailsListForm.list.PENumber
                  : ''}
              </span>
            </Grid>
            <Grid className="subContainerSubTitle">
              <p>Visualice los detalles de un formulario enviado</p>
            </Grid>
          </Grid>

          <Grid container md={12} sm={12}>
            <Grid item md={12} sm={12} xs={12} className="generalTitle">
              <p>Información General</p>
            </Grid>

            <Grid container spacing={2} className="generalInfo">
              <Grid item md={4} sm={4} xs={12}>
                <p
                  style={{
                    color: '#0c70b5',
                    fontWeight: '900',
                    fontSize: '18px',
                  }}
                >
                  Fecha
                </p>
                <FormControl style={{ width: '100%' }}>
                  <TextField
                    id="fullName"
                    style={{ width: '100%', background: '#f5f8fa' }}
                    variant="outlined"
                    value={formData.DateCreated ? formData.DateCreated : ''}
                    className="Mui-disabled"
                    disabled
                  />
                </FormControl>
              </Grid>
              <Grid item md={4} sm={4} xs={12}>
                <p
                  style={{
                    color: '#0c70b5',
                    fontWeight: '900',
                    fontSize: '18px',
                  }}
                >
                  Proyecto #
                </p>
                <FormControl style={{ width: '100%' }}>
                  <TextField
                    id="fullName"
                    style={{ width: '100%', background: '#f5f8fa' }}
                    variant="outlined"
                    value={
                      formData.ProjectPreElegibilityCode
                        ? formData.ProjectPreElegibilityCode
                        : ''
                    }
                    className="Mui-disabled"
                    disabled
                  />
                </FormControl>
              </Grid>
              <Grid item md={4} sm={4} xs={12}>
                <p
                  style={{
                    color: '#0c70b5',
                    fontWeight: '900',
                    fontSize: '18px',
                  }}
                >
                  IFI
                </p>
                <FormControl style={{ width: '100%' }}>
                  <TextField
                    id="fullName"
                    style={{ width: '100%', background: '#f5f8fa' }}
                    variant="outlined"
                    value={formData.IFIName ? formData.IFIName : ''}
                    className="Mui-disabled"
                    disabled
                  />
                </FormControl>
              </Grid>
              <Grid item md={2} sm={2} xs={12}>
                <p
                  style={{
                    color: '#0c70b5',
                    fontWeight: '900',
                    fontSize: '18px',
                  }}
                >
                  Monto Requerido
                </p>
                <FormControl style={{ width: '100%' }}>
                  {/* <TextField
                    id="fullName"
                    style={{
                      width: '100%',
                      background: '#f5f8fa',
                      fontSize: '20px',
                    }}
                    variant="outlined"
                    value={
                      detailsListForm?.list?.RequiredAmountSourceCurrency &&
                      detailsListForm?.list?.RequiredAmountSourceCurrency !==
                        '0.00'
                        ? detailsListForm?.list?.RequiredAmountSourceCurrency
                        : detailsListForm?.list?.RequiredAmountDollarsCurrency
                        ? detailsListForm?.list?.RequiredAmountDollarsCurrency
                        : ''
                    }
                    className="Mui-disabled"
                    disabled
                  /> */}

                  <NumberFormat
                    id="fullName"
                    style={{
                      width: '100%',
                      background: '#f5f8fa',
                      fontSize: '20px',
                    }}
                    variant="outlined"
                    thousandSeparator={true}
                    value={
                      detailsListForm?.list?.RequiredAmountSourceCurrency &&
                      detailsListForm?.list?.RequiredAmountSourceCurrency !==
                        '0.00'
                        ? detailsListForm?.list?.RequiredAmountSourceCurrency
                        : detailsListForm?.list?.RequiredAmountDollarsCurrency
                        ? detailsListForm?.list?.RequiredAmountDollarsCurrency
                        : ''
                    }
                    autoComplete="off"
                    allowNegative={false}
                    disabled
                    isNumericString={true}
                    inputProps={{ maxLength: 12 }}
                    fixedDecimalScale
                    decimalScale={2}
                    customInput={TextField}
                    className="Mui-disabled"
                  />
                </FormControl>
              </Grid>

              <Grid item md={2} sm={2} xs={12}>
                <p
                  style={{
                    color: '#0c70b5',
                    fontWeight: '900',
                    fontSize: '18px',
                  }}
                >
                  Moneda del Monto
                </p>
                <FormControl style={{ width: '100%' }}>
                  <TextField
                    style={{
                      width: '100%',
                      background: '#f5f8fa',
                      fontSize: '20px',
                    }}
                    variant="outlined"
                    value={
                      detailsListForm?.list?.RequiredAmountSourceCurrency &&
                      detailsListForm?.list?.Currency?.Description
                        ? detailsListForm?.list?.Currency?.Description
                        : 'Dolares'
                    }
                    className="Mui-disabled"
                    disabled
                  />
                </FormControl>
              </Grid>

              <Grid item md={2} sm={2} xs={12}>
                <p
                  style={{
                    color: '#0c70b5',
                    fontWeight: '900',
                    fontSize: '18px',
                  }}
                >
                  Monto en Dólares $
                </p>
                <FormControl style={{ width: '100%' }}>
                  {/* <TextField
                    id="fullName"
                    style={{
                      width: '100%',
                      background: '#f5f8fa',
                      fontSize: '20px',
                    }}
                    variant="outlined"
                    value={
                      detailsListForm?.list?.RequiredAmountDollarsCurrency
                        ? detailsListForm?.list?.RequiredAmountDollarsCurrency
                        : ''
                    }
                    className="Mui-disabled"
                    disabled
                  /> */}

                  <NumberFormat
                    id="fullName"
                    style={{
                      width: '100%',
                      background: '#f5f8fa',
                      fontSize: '20px',
                    }}
                    variant="outlined"
                    thousandSeparator={true}
                    value={
                      detailsListForm?.list?.RequiredAmountDollarsCurrency
                        ? detailsListForm?.list?.RequiredAmountDollarsCurrency
                        : ''
                    }
                    autoComplete="off"
                    allowNegative={false}
                    disabled
                    isNumericString={true}
                    inputProps={{ maxLength: 12 }}
                    fixedDecimalScale
                    decimalScale={2}
                    customInput={TextField}
                    className="Mui-disabled"
                  />
                </FormControl>
              </Grid>

              <Grid item md={2} sm={2} xs={12}>
                <p
                  style={{
                    color: '#0c70b5',
                    fontWeight: '900',
                    fontSize: '18px',
                  }}
                >
                  Moneda del Monto
                </p>
                <FormControl style={{ width: '100%' }}>
                  <TextField
                    id="fullName"
                    style={{
                      width: '100%',
                      background: '#f5f8fa',
                      fontSize: '20px',
                    }}
                    variant="outlined"
                    value="Dólares"
                    className="Mui-disabled"
                    disabled
                  />
                </FormControl>
              </Grid>

              <Grid item md={4} sm={4} xs={12}>
                <p
                  style={{
                    color: '#0c70b5',
                    fontWeight: '900',
                    fontSize: '18px',
                  }}
                >
                  Estado Actual Del Formulario
                </p>
                <FormControl style={{ width: '100%' }}>
                  <TextField
                    id="fullName"
                    style={{
                      width: '100%',
                      background: '#f5f8fa',
                      fontSize: '20px',
                    }}
                    variant="outlined"
                    value={
                      formData.FormStatusDescription
                        ? formData.FormStatusDescription
                        : ''
                    }
                    className="Mui-disabled"
                    disabled
                  />
                </FormControl>
              </Grid>
            </Grid>

            <div className="divisorGeneral"></div>

            <Grid container spacing={2} className="generalInfo">
              <Grid md={12} sm={12} className="detailTitle">
                <p>Detalles de la MIPYME</p>
              </Grid>
              <Grid item md={12} sm={12} xs={12}>
                <p
                  style={{
                    color: '#0c70b5',
                    fontWeight: '900',
                    fontSize: '18px',
                  }}
                >
                  Nombre Completo
                </p>
                <FormControl style={{ width: '100%' }}>
                  <TextField
                    id="fullName"
                    style={{
                      width: '100%',
                      background: '#f5f8fa',
                      fontSize: '20px',
                    }}
                    variant="outlined"
                    value={
                      detailsListForm?.list?.UserFullName
                        ? detailsListForm?.list?.UserFullName
                        : ''
                    }
                    className="Mui-disabled"
                    disabled
                  />
                </FormControl>
              </Grid>
              <Grid item md={12} sm={12} xs={12}>
                <p
                  style={{
                    color: '#0c70b5',
                    fontWeight: '900',
                    fontSize: '18px',
                  }}
                >
                  Nombre Proyecto
                </p>
                <FormControl style={{ width: '100%' }}>
                  <TextField
                    id="fullName"
                    style={{
                      width: '100%',
                      background: '#f5f8fa',
                      fontSize: '20px',
                    }}
                    variant="outlined"
                    value={
                      formData.SubprojectName ? formData.SubprojectName : ''
                    }
                    className="Mui-disabled"
                    disabled
                  />
                </FormControl>
              </Grid>
              <Grid item md={12} sm={12} xs={12}>
                <p
                  style={{
                    color: '#0c70b5',
                    fontWeight: '900',
                    fontSize: '18px',
                  }}
                >
                  Representante Legal
                </p>
                <FormControl style={{ width: '100%' }}>
                  <TextField
                    id="fullName"
                    style={{
                      width: '100%',
                      background: '#f5f8fa',
                      fontSize: '20px',
                    }}
                    variant="outlined"
                    value={
                      detailsListForm?.list?.LegalRepresentativeName
                        ? detailsListForm?.list?.LegalRepresentativeName
                        : ''
                    }
                    className="Mui-disabled"
                    disabled
                  />
                </FormControl>
              </Grid>
              <Grid item md={12} sm={12} xs={12}>
                <p
                  style={{
                    color: '#0c70b5',
                    fontWeight: '900',
                    fontSize: '18px',
                  }}
                >
                  Identificación Representante
                </p>
                <FormControl style={{ width: '100%' }}>
                  <TextField
                    id="fullName"
                    style={{
                      width: '100%',
                      background: '#f5f8fa',
                      fontSize: '20px',
                    }}
                    variant="outlined"
                    value={
                      formData.IdentificationLegalRepresentative
                        ? formData.IdentificationLegalRepresentative
                        : ''
                    }
                    className="Mui-disabled"
                    disabled
                  />
                </FormControl>
              </Grid>
              <Grid item md={12} sm={12} xs={12}>
                <p
                  style={{
                    color: '#0c70b5',
                    fontWeight: '900',
                    fontSize: '18px',
                  }}
                >
                  Nombre MIPYME
                </p>
                <FormControl style={{ width: '100%' }}>
                  <TextField
                    id="fullName"
                    style={{
                      width: '100%',
                      background: '#f5f8fa',
                      fontSize: '20px',
                    }}
                    variant="outlined"
                    value={
                      detailsListForm?.list?.MiPyme?.BusinessName
                        ? detailsListForm?.list?.MiPyme?.BusinessName
                        : ''
                    }
                    className="Mui-disabled"
                    disabled
                  />
                </FormControl>
              </Grid>
              <Grid item md={12} sm={12} xs={12}>
                <p
                  style={{
                    color: '#0c70b5',
                    fontWeight: '900',
                    fontSize: '18px',
                  }}
                >
                  Tipo MIPYME
                </p>
                <FormControl style={{ width: '100%' }}>
                  <TextField
                    id="fullName"
                    style={{
                      width: '100%',
                      background: '#f5f8fa',
                      fontSize: '20px',
                    }}
                    variant="outlined"
                    value={
                      detailsListForm?.list?.MiPymeTypes
                        ? detailsListForm?.list?.MiPymeTypes?.Description
                        : ''
                    }
                    className="Mui-disabled"
                    disabled
                  />
                </FormControl>
              </Grid>
              <Grid item md={12} sm={12} xs={12}>
                <p
                  style={{
                    color: '#0c70b5',
                    fontWeight: '900',
                    fontSize: '18px',
                  }}
                >
                  Registro Tributario
                </p>
                <FormControl style={{ width: '100%' }}>
                  <TextField
                    id="fullName"
                    style={{
                      width: '100%',
                      background: '#f5f8fa',
                      fontSize: '20px',
                    }}
                    variant="outlined"
                    value={
                      detailsListForm?.list?.MiPyme?.TaxRegistration
                        ? detailsListForm?.list?.MiPyme?.TaxRegistration
                        : ''
                    }
                    className="Mui-disabled"
                    disabled
                  />
                </FormControl>
              </Grid>

              <Grid item md={12} sm={12} xs={12}>
                <p
                  style={{
                    color: '#0c70b5',
                    fontWeight: '900',
                    fontSize: '18px',
                  }}
                >
                  Empleados Permanentes #
                </p>
                <FormControl style={{ width: '100%' }}>
                  <TextField
                    id="fullName"
                    style={{
                      width: '100%',
                      background: '#f5f8fa',
                      fontSize: '20px',
                    }}
                    variant="outlined"
                    value={
                      detailsListForm?.list?.QuantityPermanentEmployees
                        ? detailsListForm?.list?.QuantityPermanentEmployees
                        : ''
                    }
                    className="Mui-disabled"
                    disabled
                  />
                </FormControl>
              </Grid>
            </Grid>

            <div className="divisorGeneral"></div>

            <Grid container spacing={2} className="generalInfo">
              <Grid md={12} sm={12} className="localizationDetail">
                <p>Localización de la MIPYME</p>
              </Grid>

              <Grid item md={12} sm={12} xs={12}>
                <p
                  style={{
                    color: '#0c70b5',
                    fontWeight: '900',
                    fontSize: '18px',
                  }}
                >
                  País
                </p>
                <FormControl style={{ width: '100%' }}>
                  <TextField
                    id="fullName"
                    style={{
                      width: '100%',
                      background: '#f5f8fa',
                      fontSize: '20px',
                    }}
                    variant="outlined"
                    value={
                      formData.CountryLargeName ? formData.CountryLargeName : ''
                    }
                    className="Mui-disabled"
                    disabled
                  />
                </FormControl>
              </Grid>
              <Grid item md={12} sm={12} xs={12}>
                <p
                  style={{
                    color: '#0c70b5',
                    fontWeight: '900',
                    fontSize: '18px',
                  }}
                >
                  Departamento/Provincia
                </p>
                <FormControl style={{ width: '100%' }}>
                  <TextField
                    id="fullName"
                    style={{
                      width: '100%',
                      background: '#f5f8fa',
                      fontSize: '20px',
                    }}
                    variant="outlined"
                    value={
                      detailsListForm?.list?.Department
                        ? detailsListForm?.list?.Department
                        : ''
                    }
                    className="Mui-disabled"
                    disabled
                  />
                </FormControl>
              </Grid>
              <Grid item md={12} sm={12} xs={12}>
                <p
                  style={{
                    color: '#0c70b5',
                    fontWeight: '900',
                    fontSize: '18px',
                  }}
                >
                  Municipio
                </p>
                <FormControl style={{ width: '100%' }}>
                  <TextField
                    id="fullName"
                    style={{
                      width: '100%',
                      background: '#f5f8fa',
                      fontSize: '20px',
                    }}
                    variant="outlined"
                    value={
                      detailsListForm?.list?.Municipality
                        ? detailsListForm?.list?.Municipality
                        : ''
                    }
                    className="Mui-disabled"
                    disabled
                  />
                </FormControl>
              </Grid>

              <Grid item md={12} sm={12} xs={12}>
                <p
                  style={{
                    color: '#0c70b5',
                    fontWeight: '900',
                    fontSize: '18px',
                  }}
                >
                  Teléfono
                </p>
                <FormControl style={{ width: '100%' }}>
                  <TextField
                    id="fullName"
                    style={{
                      width: '100%',
                      background: '#f5f8fa',
                      fontSize: '20px',
                    }}
                    variant="outlined"
                    value={
                      detailsListForm?.list?.Phone
                        ? detailsListForm?.list?.Phone
                        : ''
                    }
                    className="Mui-disabled"
                    disabled
                  />
                </FormControl>
              </Grid>
              <Grid item md={12} sm={12} xs={12}>
                <p
                  style={{
                    color: '#0c70b5',
                    fontWeight: '900',
                    fontSize: '18px',
                  }}
                >
                  Dirección
                </p>
                <FormControl style={{ width: '100%' }}>
                  <TextField
                    id="fullName"
                    style={{
                      width: '100%',
                      background: '#f5f8fa',
                      fontSize: '20px',
                    }}
                    variant="outlined"
                    value={
                      detailsListForm?.list?.Address
                        ? detailsListForm?.list?.Address
                        : ''
                    }
                    className="Mui-disabled"
                    disabled
                  />
                </FormControl>
              </Grid>
            </Grid>

            <div className="divisorGeneral"></div>

            <Grid
              container
              spacing={1}
              style={{ marginTop: '20px' }}
              className="generalInfo"
            >
              <Grid md={12} sm={12} xs={12} className="detailEvalTitle">
                <p
                  style={{
                    fontSize: '20px',
                    fontWeight: 'bold',
                    marginBottom: '20px',
                  }}
                >
                  Detalles De Evaluación
                </p>
              </Grid>
              <Grid item md={12} sm={12} xs={12}>
                <p
                  style={{
                    color: '#0c70b5',
                    fontWeight: '900',
                    fontSize: '18px',
                  }}
                >
                  Sector
                </p>
                <FormControl style={{ width: '100%' }}>
                  <TextField
                    id="fullName"
                    style={{
                      width: '100%',
                      background: '#f5f8fa',
                      fontSize: '20px',
                    }}
                    variant="outlined"
                    value={
                      detailsListForm?.list?.Sector?.Description
                        ? detailsListForm?.list.Sector?.Description
                        : ''
                    }
                    className="Mui-disabled"
                    disabled
                  />
                </FormControl>
              </Grid>
              <Grid item md={12} sm={12} xs={12}>
                <p
                  style={{
                    color: '#0c70b5',
                    fontWeight: '900',
                    fontSize: '18px',
                  }}
                >
                  Detalle de Sector
                </p>
                <FormControl style={{ width: '100%' }}>
                  <TextField
                    id="fullName"
                    style={{
                      width: '100%',
                      background: '#f5f8fa',
                      fontSize: '20px',
                    }}
                    variant="outlined"
                    value={
                      detailsListForm?.list?.DetailSector
                        ? detailsListForm?.list?.DetailSector
                        : ''
                    }
                    className="Mui-disabled"
                    disabled
                  />
                </FormControl>
              </Grid>
              <Grid item md={12} sm={12} xs={12}>
                <p
                  style={{
                    color: '#0c70b5',
                    fontWeight: '900',
                    fontSize: '18px',
                  }}
                >
                  Actividad
                </p>
                <FormControl style={{ width: '100%' }}>
                  <TextField
                    id="fullName"
                    style={{
                      width: '100%',
                      background: '#f5f8fa',
                      fontSize: '20px',
                    }}
                    variant="outlined"
                    value={
                      detailsListForm?.list?.Activity
                        ? detailsListForm?.list?.Activity?.Description
                        : ''
                    }
                    className="Mui-disabled"
                    disabled
                  />
                </FormControl>
              </Grid>
              <Grid item md={12} sm={12} xs={12}>
                <p
                  style={{
                    color: '#0c70b5',
                    fontWeight: '900',
                    fontSize: '18px',
                  }}
                >
                  Detalle de Actividad
                </p>
                <FormControl style={{ width: '100%' }}>
                  <TextField
                    style={{
                      width: '100%',
                      background: '#f5f8fa',
                      fontSize: '20px',
                    }}
                    variant="outlined"
                    value={
                      detailsListForm?.list?.DetailActivity
                        ? detailsListForm?.list?.DetailActivity
                        : ''
                    }
                    className="Mui-disabled"
                    disabled
                  />
                </FormControl>
              </Grid>
              <Grid item md={12} sm={12} xs={12}>
                <p
                  style={{
                    color: '#0c70b5',
                    fontWeight: '900',
                    fontSize: '18px',
                  }}
                >
                  Afecta Patrimonio Cultural
                </p>
                <FormControl style={{ width: '100%' }}>
                  <TextField
                    style={{
                      width: '100%',
                      background: '#f5f8fa',
                      fontSize: '20px',
                    }}
                    variant="outlined"
                    value={
                      detailsListForm?.list?.AffectsCulturalHeritage &&
                      detailsListForm?.list?.AffectsCulturalHeritage
                        ? 'Si'
                        : 'No'
                    }
                    className="Mui-disabled"
                    disabled
                  />
                </FormControl>
              </Grid>
              <Grid item md={12} sm={12} xs={12}>
                <p
                  style={{
                    color: '#0c70b5',
                    fontWeight: '900',
                    fontSize: '18px',
                  }}
                >
                  Detalles Patrimonio Cultural
                </p>
                <FormControl style={{ width: '100%' }}>
                  <TextField
                    style={{
                      width: '100%',
                      background: '#f5f8fa',
                      fontSize: '20px',
                    }}
                    variant="outlined"
                    value={
                      detailsListForm?.list?.DetailAffectsCulturalHeritage
                        ? detailsListForm?.list?.DetailAffectsCulturalHeritage
                        : ''
                    }
                    className="Mui-disabled"
                    disabled
                  />
                </FormControl>
              </Grid>
              <Grid item md={12} sm={12} xs={12}>
                <p
                  style={{
                    color: '#0c70b5',
                    fontWeight: '900',
                    fontSize: '18px',
                  }}
                >
                  Área Protegida
                </p>
                <FormControl style={{ width: '100%' }}>
                  <TextField
                    style={{
                      width: '100%',
                      background: '#f5f8fa',
                      fontSize: '20px',
                    }}
                    variant="outlined"
                    value={
                      detailsListForm?.list?.IsInProtectedArea &&
                      detailsListForm?.list?.IsInProtectedArea
                        ? 'Si'
                        : 'No'
                    }
                    className="Mui-disabled"
                    disabled
                  />
                </FormControl>
              </Grid>
              <Grid item md={12} sm={12} xs={12}>
                <p
                  style={{
                    color: '#0c70b5',
                    fontWeight: '900',
                    fontSize: '18px',
                  }}
                >
                  Detalles Área Protegida
                </p>
                <FormControl style={{ width: '100%' }}>
                  <TextField
                    style={{
                      width: '100%',
                      background: '#f5f8fa',
                      fontSize: '20px',
                    }}
                    variant="outlined"
                    value={
                      detailsListForm?.list?.ProtectedAreaLocation
                        ? detailsListForm?.list?.ProtectedAreaLocation
                        : ''
                    }
                    className="Mui-disabled"
                    disabled
                  />
                </FormControl>
              </Grid>
              <Grid item md={12} sm={12} xs={12}>
                <p
                  style={{
                    color: '#0c70b5',
                    fontWeight: '900',
                    fontSize: '18px',
                  }}
                >
                  Amenaza Climática
                </p>
                <FormControl style={{ width: '100%' }}>
                  <TextField
                    style={{
                      width: '100%',
                      background: '#f5f8fa',
                      fontSize: '20px',
                    }}
                    variant="outlined"
                    value={
                      detailsListForm?.list?.ClimateThreat?.Description
                        ? detailsListForm?.list?.ClimateThreat.Description
                        : ''
                    }
                    className="Mui-disabled"
                    disabled
                  />
                </FormControl>
              </Grid>
              <Grid item md={12} sm={12} xs={12}>
                <p
                  style={{
                    color: '#0c70b5',
                    fontWeight: '900',
                    fontSize: '18px',
                  }}
                >
                  Detalles Amenaza Climática
                </p>
                <FormControl style={{ width: '100%' }}>
                  <TextField
                    style={{
                      width: '100%',
                      background: '#f5f8fa',
                      fontSize: '20px',
                    }}
                    variant="outlined"
                    value={
                      detailsListForm?.list?.DetailClimateThreat
                        ? detailsListForm?.list?.DetailClimateThreat
                        : ''
                    }
                    className="Mui-disabled"
                    disabled
                  />
                </FormControl>
              </Grid>
              <Grid item md={12} sm={12} xs={12}>
                <p
                  style={{
                    color: '#0c70b5',
                    fontWeight: '900',
                    fontSize: '18px',
                  }}
                >
                  Impactos Negativos
                </p>
                <FormControl style={{ width: '100%' }}>
                  <TextField
                    style={{
                      width: '100%',
                      background: '#f5f8fa',
                      fontSize: '20px',
                    }}
                    variant="outlined"
                    value={impactos}
                    className="Mui-disabled"
                    disabled
                  />
                </FormControl>
              </Grid>

              <Grid item md={12} sm={12} xs={12}>
                <p
                  style={{
                    color: '#0c70b5',
                    fontWeight: '900',
                    fontSize: '18px',
                  }}
                >
                  Adaptación a Implementar
                </p>
                <FormControl style={{ width: '100%' }}>
                  <TextField
                    style={{
                      width: '100%',
                      background: '#f5f8fa',
                      fontSize: '20px',
                    }}
                    variant="outlined"
                    className="Mui-disabled"
                    value={
                      detailsListForm?.list?.AdaptationActions?.Description
                        ? detailsListForm?.list?.AdaptationActions?.Description
                        : ''
                    }
                    disabled
                  />
                </FormControl>
              </Grid>
              <Grid item md={12} sm={12} xs={12}>
                <p
                  style={{
                    color: '#0c70b5',
                    fontWeight: '900',
                    fontSize: '18px',
                  }}
                >
                  Detalles Adaptación
                </p>
                <FormControl style={{ width: '100%' }}>
                  <TextField
                    style={{
                      width: '100%',
                      background: '#f5f8fa',
                      fontSize: '20px',
                    }}
                    variant="outlined"
                    value={
                      detailsListForm?.list?.DetailAdaptationActions
                        ? detailsListForm?.list?.DetailAdaptationActions
                        : ''
                    }
                    className="Mui-disabled"
                    disabled
                  />
                </FormControl>
              </Grid>

              <Grid item md={12} sm={12} xs={12}>
                <p
                  style={{
                    color: '#0c70b5',
                    fontWeight: '900',
                    fontSize: '18px',
                  }}
                >
                  Consideraciones especiales
                </p>
                <FormControl style={{ width: '100%' }}>
                  <TextField
                    style={{
                      width: '100%',
                      background: '#f5f8fa',
                      fontSize: '20px',
                    }}
                    variant="outlined"
                    value={
                      detailsListForm?.list?.BusinessLine?.Description
                        ? detailsListForm?.list?.BusinessLine?.Description
                        : ''
                    }
                    className="Mui-disabled"
                    disabled
                  />
                </FormControl>
              </Grid>
            </Grid>
            <div className="divisorGeneral"></div>

            {detailsListForm?.list?.AnnexAnswer &&
            detailsListForm?.list?.AnnexAnswer !== null ? (
              <Grid
                container
                md={12}
                sm={12}
                xs={12}
                spacing={12}
                style={{ marginTop: '20px' }}
                className="generalInfo"
              >
                <Grid md={12} sm={12} xs={12} className="evalQuestionTitle">
                  <p>Preguntas De Evaluación</p>
                </Grid>
                {detailsListForm?.list?.AnnexAnswer &&
                  detailsListForm.list.AnnexAnswer.map((item, key) => {
                    return (
                      <>
                        {/* {selectedClass && selectedClass !== '' ? (
                          <Grid
                            item
                            md={12}
                            sm={12}
                            xs={12}
                            key={key}
                            style={{ marginTop: '20px' }}
                          >
                            <p
                              style={{
                                color: '#0c70b5',
                                fontWeight: '900',
                                fontSize: '18px',
                              }}
                            >
                              Clase
                            </p>
                            <FormControl style={{ width: '100%' }}>
                              <TextField
                                style={{
                                  width: '100%',
                                  background: '#f5f8fa',
                                  fontSize: '20px',
                                }}
                                variant="outlined"
                                value={selectedClass}
                                className="Mui-disabled"
                                disabled
                              />
                            </FormControl>
                          </Grid>
                        ) : null}
                        <Grid
                          item
                          md={12}
                          sm={12}
                          xs={12}
                          key={key}
                          style={{ marginTop: '20px' }}
                        >
                          <p
                            style={{
                              color: '#0c70b5',
                              fontWeight: '900',
                              fontSize: '18px',
                            }}
                          >
                            {item.activityQuestion &&
                            item.activityQuestion !== ''
                              ? item?.activityQuestion?.toLowerCase() ===
                                'Porcentaje de pendiente del terreno'.toLowerCase()
                                ? 'Porcentaje de pendiente del terreno' +
                                  percentageClass
                                : item.activityQuestion
                              : null}
                          </p>
                          <FormControl style={{ width: '100%' }}>
                            <TextField
                              style={{
                                width: '100%',
                                background: '#f5f8fa',
                                fontSize: '20px',
                              }}
                              variant="outlined"
                              value={
                                item?.activityQuestion?.toLowerCase() ===
                                'Porcentaje de pendiente del terreno'.toLowerCase()
                                  ? item.answer.split('|')[1]
                                  : item.answer
                              }
                              className="Mui-disabled"
                              disabled
                            />
                          </FormControl>
                        </Grid> */}
                        <Grid
                          item
                          md={12}
                          sm={12}
                          xs={12}
                          key={key}
                          style={{ marginTop: '20px' }}
                        >
                          <p
                            style={{
                              color: '#0c70b5',
                              fontWeight: '900',
                              fontSize: '18px',
                            }}
                          >
                            {item.QuestionName}
                          </p>
                          <FormControl style={{ width: '100%' }}>
                            {item.ValueType === 'Decimal' ? (
                              <NumberFormat
                                name="questionDecimal"
                                style={{ width: '100%' }}
                                customInput={TextField}
                                thousandSeparator={true}
                                disabled
                                value={Number(item.Value)}
                                autoComplete="off"
                                allowNegative={false}
                                variant="outlined"
                                isNumericString={true}
                                inputProps={{
                                  maxLength: 18,
                                  min: 0,
                                  autoComplete: 'off',
                                }}
                                fixedDecimalScale
                                decimalScale={2}
                              />
                            ) : item.ValueType === 'Numeric' ? (
                              <NumberFormat
                                name="questionDecimal"
                                style={{ width: '100%' }}
                                customInput={TextField}
                                thousandSeparator={true}
                                disabled
                                value={Number(item.Value)}
                                autoComplete="off"
                                allowNegative={false}
                                variant="outlined"
                                isNumericString={true}
                                inputProps={{
                                  maxLength: 18,
                                  min: 0,
                                  autoComplete: 'off',
                                }}
                                decimalScale={0}
                              />
                            ) : (
                              <TextField
                                style={{
                                  width: '100%',
                                  background: '#f5f8fa',
                                  fontSize: '20px',
                                }}
                                variant="outlined"
                                value={item.Value}
                                className="Mui-disabled"
                                disabled
                              />
                            )}
                          </FormControl>
                        </Grid>
                      </>
                    )
                  })}
              </Grid>
            ) : null}
          </Grid>
        </Grid>
      ) : (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '90%',
            height: '80vh',
            borderRadius: '20px',
            padding: '40px',

            background: '#fff',
          }}
        >
          <CircularProgress />
        </Box>
      )}

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Formulario #{' '}
            <Button
              style={{
                backgroundColor: '#055bc3',
                borderRadius: '5px',
                color: '#fff',
                fontWeight: 'bold',
                fontSize: '15px',
                marginLeft: '10px',
              }}
            >
              {formData.ProjectPreElegibilityCode
                ? formData.ProjectPreElegibilityCode
                : ''}
            </Button>
            <Button
              style={{
                backgroundColor: '#055bc3',
                borderRadius: '5px',
                color: '#fff',
                fontWeight: 'bold',
                fontSize: '15px',
                marginLeft: '10px',
              }}
            >
              {formData.FormStatusDescription
                ? formData.FormStatusDescription
                : ''}
            </Button>
          </Typography>
          <Typography
            id="modal-modal-description"
            sx={{ mt: 2 }}
            style={{ fontWeight: '400', fontSize: '18px' }}
          >
            Seleccione un estado:
          </Typography>
          <FormControl fullWidth>
            <Select
              value={actualStatus}
              onChange={(e) => {
                handleState(e.target.value)
              }}
            >
              <MenuItem value={0}>Seleccione una estado</MenuItem>
              {statesCodes &&
                statesCodes.map((item, key) => (
                  <MenuItem key={item.id} value={item.id}>
                    {item.value}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
          <Typography
            id="modal-modal-description"
            sx={{ mt: 2 }}
            style={{ fontWeight: '400', fontSize: '18px' }}
          >
            Observaciones:
          </Typography>
          <FormControl fullWidth style={{ marginTop: '0px' }}>
            <TextareaAutosize
              aria-label="minimum height"
              minRows={3}
              placeholder="Observaciones..."
              style={{ resize: 'none' }}
              onChange={(e) => {
                handleObservations(e.target.value)
              }}
            />
          </FormControl>

          <FormControl fullWidth>
            <p>
              se debe corregir el monto ?{' '}
              <Switch
                checked={amountChange}
                onChange={handleSwitchChange}
                inputProps={{ 'aria-label': 'controlled' }}
              />
            </p>
          </FormControl>
          <Grid
            container
            md={12}
            sm={12}
            style={{
              marginTop: '10px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            {loadingUpdate ? (
              <Box
                style={{
                  marginTop: '10px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <CircularProgress />
              </Box>
            ) : (
              <></>
            )}
          </Grid>
          <Grid style={{ marginTop: '10px' }}>
            <Button
              style={{
                background: 'rgb(255, 167, 0)',
                fontWeight: 'bold',
                color: '#fff',
              }}
              onClick={() => handleClose()}
            >
              Cancelar
            </Button>
            {buttonEnable ? (
              <Button
                style={{
                  background: '#27c27e',
                  fontWeight: 'bold',
                  marginLeft: '10px',
                  color: '#fff',
                }}
                onClick={() => updateStatus()}
              >
                Actualizar
              </Button>
            ) : (
              <Button
                style={{
                  background: '#eee',
                  fontWeight: 'bold',
                  marginLeft: '10px',
                  color: '#fff',
                }}
                disabled
              >
                Actualizar
              </Button>
            )}
          </Grid>
        </Box>
      </Modal>
    </Grid>
  )
}

export default DetailsForm
